import { App } from 'vue';
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
  install(app: App, options: ToastContainerOptions = {}) {
    app.use(Vue3Toastify, options);
  }
};